import LearnVisualFrame from "./LearnVisualFrame";
import p from "./visualPalette";

export default function DrillGeometryVisual({ title, takeaway, caption }) {
  return (
    <LearnVisualFrame title={title} takeaway={takeaway} caption={caption} size="large">
      <svg viewBox="0 0 820 390" role="img" aria-label="Cross-section showing a drill hole crossing a dipping mineralized body, with the reported downhole interval measured along the drill hole and true width shown separately across the body.">
        <path d="M50 82 H770" stroke={p.ink} strokeWidth="2" />
        <text x="56" y="66" fontSize="13" fontWeight="850" fill={p.muted}>Surface</text>

        <line x1="322" y1="82" x2="456" y2="328" stroke={p.ink} strokeWidth="3" />
        <text x="255" y="118" fontSize="13" fontWeight="850" fill={p.muted}>Drill hole</text>

        <polygon points="208,248 618,176 652,224 242,296" fill="rgba(201,176,123,0.16)" stroke={p.line} strokeWidth="2" />
        <text x="574" y="166" fontSize="13" fontWeight="850" fill={p.ink}>Mineralized body</text>

        <line x1="386" y1="198" x2="426" y2="272" stroke={p.gold} strokeWidth="8" strokeLinecap="round" />
        <line x1="382" y1="198" x2="430" y2="272" stroke={p.gold} strokeWidth="1.5" />
        <text x="445" y="228" fontSize="13" fontWeight="900" fill={p.ink}>Reported downhole interval</text>
        <path d="M432 226 H604" stroke={p.softLine} strokeWidth="1.5" />

        <line x1="402" y1="216" x2="422" y2="268" stroke={p.ink} strokeWidth="2.5" strokeDasharray="5 5" />
        <path d="M402 216 l8 12 l-14 5 z" fill={p.ink} />
        <path d="M422 268 l-8 -12 l14 -5 z" fill={p.ink} />
        <text x="314" y="286" fontSize="13" fontWeight="900" fill={p.ink}>Approximate true width</text>
        <path d="M438 268 H298" stroke={p.softLine} strokeWidth="1.5" />

        <line x1="322" y1="82" x2="322" y2="328" stroke={p.softLine} strokeWidth="1.5" strokeDasharray="5 5" />
        <text x="336" y="344" fontSize="13" fontWeight="850" fill={p.muted}>Depth context</text>
      </svg>
    </LearnVisualFrame>
  );
}
